import { render, staticRenderFns } from "./create-workspace.vue?vue&type=template&id=238701e0&scoped=true"
import script from "./create-workspace.vue?vue&type=script&lang=js"
export * from "./create-workspace.vue?vue&type=script&lang=js"
import style0 from "./create-workspace.vue?vue&type=style&index=0&id=238701e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238701e0",
  null
  
)

export default component.exports